export const PREVIEW_DIMENSION = 128;
export const STORAGE_KEY = 'picsart_drafts_';
export const DEFAULT_PROJECT_NAME = 'Untitled';
export const VERSION = 1;
